"use client";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * MUI LocalizationProvider using Dayjs adapter
 *
 * NOTE: This provider uses Dayjs for MUI date picker type consistency.
 * The rmh-patient app should primarily use Luxon for date operations outside of MUI components.
 * This provider is currently used app-wide but is primarily intended for dashboard routes
 * where MUI date pickers are used.
 *
 * TODO: Migrate non-dashboard, non-MUI date handling code to use Luxon
 */
const MuiLocalizationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      {children}
    </LocalizationProvider>
  );
};

export default MuiLocalizationProvider;
